import { EpisodeOfCareRelatedConditionschema } from "@/modules/patients/detail/episode-of-care/components/related-conditions-form"
import { PatientConditionInformationOutputFragment$data } from "@/modules/patients/services/__generated__/PatientConditionInformationOutputFragment.graphql"
import { Ch_updateAllPatientConditionsInput } from "@/modules/patients/services/ch/__generated__/chUpdateAllPatientConditionsMutation.graphql"
import { De_updateAllPatientConditionsInput } from "@/modules/patients/services/de/__generated__/deUpdateAllPatientConditionsMutation.graphql"

export const handleUpdateAllPatientCondition = (
  patientId: string,
  patientConditionData: PatientConditionInformationOutputFragment$data,
  relatedConditions: EpisodeOfCareRelatedConditionschema["relatedConditions"],
  handleUpdateAllCondition: (input: De_updateAllPatientConditionsInput & Ch_updateAllPatientConditionsInput) => void,
) => {
  const patientConditions = patientConditionData.conditions.map((c) => ({
    comment: c.comment,
    diagnosisCode: c.icdDiagnosis.diagnosisCode,
  }))

  let willUpdatePatientConditions = false
  const linkedConditions = relatedConditions.filter((r) => r.isFromIcdSelectInThisSession && r.value)

  for (const linkedCondition of linkedConditions) {
    if (patientConditions.every((c) => c.diagnosisCode !== linkedCondition.icdCode)) {
      willUpdatePatientConditions = true
      patientConditions.push({
        comment: null,
        diagnosisCode: linkedCondition.icdCode,
      })
    }
  }

  if (willUpdatePatientConditions) {
    const patientConditionSubmitData: De_updateAllPatientConditionsInput & Ch_updateAllPatientConditionsInput = {
      patientId,
      conditions: patientConditions,
    }

    handleUpdateAllCondition(patientConditionSubmitData)
  }
}
